
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/api/partner",
      function () {
        return require("private-next-pages/docs/api/partner.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/api/partner"])
      });
    }
  